import {inject, injectable} from 'inversify';

import {RemoteFileStorageService} from '../../system/remoteFileStorage/RemoteFileStorage.service';
import {SaveMediaToCachedMediaDbUseCase} from '../../useCases/Media/SaveMediaToCachedMediaDb.uc';
import {CachedMediaModel} from './CachedMedia.model';

@injectable()
export class CachedMediaFactory {
  constructor(
    @inject(RemoteFileStorageService)
    private readonly remoteFileStorageService: RemoteFileStorageService,
    @inject(SaveMediaToCachedMediaDbUseCase)
    private readonly saveMediaToCachedMediaDbUseCase: SaveMediaToCachedMediaDbUseCase,
  ) {}

  create() {
    return new CachedMediaModel(
      this.remoteFileStorageService,
      this.saveMediaToCachedMediaDbUseCase,
    );
  }
}
